<template>
  <div
    v-if="!!announcementBannerData"
    ref="bannerRef"
    class="text-center p-4"
    :style="getAnnouncementBackgroundStyling(announcementBannerData.backgroundColor)"
  >
    <div class="contents" v-html="announcementBannerData.message"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, nextTick, defineEmits } from 'vue';
import DOMPurify from 'isomorphic-dompurify';
import { useIframeStore } from '@/stores/chatAIStore';
interface AnnouncementBannerData {
  message: string;
  backgroundColor: string;
}

// Reactive reference to the banner div
const bannerRef = ref<HTMLElement | null>(null);
const height = ref<number>(0);
const iframeStore = useIframeStore();
const model = "announcement-banner";
const route = useRoute();
const { data: announcementBannerData } = await useAsyncData(
  () => builderIoService().fetchOneModel<AnnouncementBannerData>(model, route.path),
  {
    transform: (data: BuilderIOData<AnnouncementBannerData>) => {
      if (!!data.data) {
        data.data.message = DOMPurify.sanitize(data.data?.message, {
          ALLOWED_TAGS: ['a', 'u', 'p', 'b', 'i', 'em', 'strong', 'span'],
          ALLOWED_ATTR: ['href', 'target', 'style', 'rel'],
        });
      }
      return data.data;
    },
  }
);
const emit = defineEmits(['height-changed']);
const getAnnouncementBackgroundStyling = (color: string | undefined) => {
  return { backgroundColor: color || 'none' };
};
onMounted(async () => {
  await nextTick(); // wait for DOM update
  if (bannerRef.value) {
    height.value = bannerRef.value.offsetHeight;
    iframeStore.annonceMentHeight = height.value
     emit('height-changed', height.value);
  }
});
</script>
